import axios from 'axios';
import { ref } from 'vue';

export function useFileActions() {
  const isLoading = ref(false);

  const errorHandler = (error: any) => {
    isLoading.value = false;
    console.error('Error while file downloading:', error);
  };

  const getBlobUrl = async (fileUrl: string) => {
    const response = await axios.get(fileUrl, {
      responseType: 'blob',
      // @ts-ignore: Ignore the TypeScript error for noAuth
      noAuth: true,
    });
    return URL.createObjectURL(response.data);
  };
  const downloadFile = async (fileUrl: string, fileName: string) => {
    try {
      isLoading.value = true;
      const blobUrl = await getBlobUrl(fileUrl);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);
      isLoading.value = false;
    } catch (error) {
      errorHandler(error);
    }
  };

  const printFile = async (fileUrl: string) => {
    try {
      isLoading.value = true;
      const oldIframe = document.querySelector('iframe[data-purpose="print"]');
      if (oldIframe) {
        document.body.removeChild(oldIframe);
      }
      const blobUrl = await getBlobUrl(fileUrl);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.setAttribute('data-purpose', 'print');

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.print();
          isLoading.value = false;
        }, 500); // A small delay for safari to load the content
      };
    } catch (error) {
      errorHandler(error);
    }
  };

  return { isLoading, downloadFile, printFile };
}

export default useFileActions;
